<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template>
                        Edycja rodzaju wysyłki
                    </template>
                </h1>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-autocomplete
                            v-model="orderDeliveryData.methodId"
                            :items="availableDeliveryMethods"
                            item-value="id"
                            item-text="name"
                            label="Transport"
                            outlined
                            dense
                            clearable
                            hide-details
                            @change="handleDeliveryMethodChange"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-text-field
                            v-model="orderDeliveryData.distance"
                            label="Dystans"
                            suffix="km"
                            min="0"
                            outlined
                            dense
                            hide-details
                            type="number"
                            inputmode="numeric"
                        />
                    </v-col>
                    <v-col cols="6">
                        <v-btn
                            color="success"
                            data-sentry-label="Oblicz"
                            :disabled="disabledStates.calculate"
                            @click="calculateDeliveryCost"
                        >
                            Oblicz koszt wysyłki
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="orderDeliveryData.cost"
                            label="Koszt"
                            suffix="zł"
                            outlined
                            dense
                            :hide-details="!transportCostError"
                            :error="!!transportCostError"
                            :hint="transportCostError"
                            @change="transportCostChange"
                        />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Dodaj"
                    :disabled="disabledStates.save"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import { mask } from 'vue-the-mask'
import parse from '@/mixins/parse'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'OrderSendingParametersDialog',
    directives: { mask },
    mixins: [ parse ],
    props: {
        isOpen: {
            type: Boolean
        },
        orderDeliveryMethod: {
            type: Object,
            default: null
        },
        deliveryMethods: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            orderDeliveryData: {
                methodId: null,
                cost: null,
                distance: null
            }
        }
    },
    computed: {
        transportCost() {
            return this.orderDeliveryData.cost
        },
        transportCostError() {
            const regex = /^\d*(\.\d{0,2})?$/
            const value = this.transportCost

            if (value === null || value === '' || value === undefined) {
                return ''
            }
            if (!regex.test(value.toString())) {
                return 'Maksymalnie 2 cyfry po przecinku'
            }

            return ''
        },
        disabledStates() {
            const distanceVal = this.orderDeliveryData.distance
            const distanceEmpty = distanceVal === '' || distanceVal === null || distanceVal === undefined

            return {
                save: !!this.transportCostError || !this.orderDeliveryData.methodId || distanceEmpty,
                calculate: !this.orderDeliveryData.methodId || distanceEmpty
            }
        },
        availableDeliveryMethods() {
            const available = this.deliveryMethods.filter(item => item.isAvailableInTransportSelection)
            const currentId = this.orderDeliveryData && this.orderDeliveryData.methodId
            let list = available

            if (currentId && !available.some(item => item.id === currentId)) {
                const current = this.deliveryMethods.find(item => item.id === currentId)

                if (current) {
                    list = [...available, current]
                }
            }

            return list
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.orderDeliveryData = JSON.parse(JSON.stringify(this.orderDeliveryMethod))
            } else {
                setTimeout(() => {
                    this.orderDeliveryData = {
                        methodId: null,
                        cost: null,
                        distance: null
                    }
                }, 500)
            }
        }
    },
    methods: {
        handleDeliveryMethodChange() {
            this.orderDeliveryData.distance = 0
            this.orderDeliveryData.cost = 0
        },
        transportCostChange() {
            this.orderDeliveryData.cost = parseFloat(this.transportCost) || 0
        },
        onSave() {
            this.$emit('on-save', this.orderDeliveryData)
        },
        onClose() {
            this.$emit('on-close')
        },
        async calculateDeliveryCost() {
            const payload = {
                deliveryMethodId: this.orderDeliveryData.methodId,
                distance: parseInt(this.orderDeliveryData.distance),
                weight: 0,
                packagesQuantities: []
            }

            return await this.$store.dispatch('calculations/calculateDeliveryCost', payload)
                .then(response => {
                    this.orderDeliveryData.cost = response.data.price
                })
                .catch(error => {
                    errorHandler(error)
                })
        }
    }
}
</script>
